import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem, StyledTable } from "./Components";

import han_haz_lev from "../img/sswpIcons/HandTools/han_haz_lev.png";
import han_cab_che from "../img/sswpIcons/HandTools/han_cab_che.png";
import han_cab_pro from "../img/sswpIcons/HandTools/han_cab_pro.png";
import han_cha_saw_ppe from "../img/sswpIcons/HandTools/han_cha_saw_ppe.png";
import han_com_whi_che from "../img/sswpIcons/HandTools/han_com_whi_che.png";
import han_con_saw_abr_whe from "../img/sswpIcons/HandTools/han_con_saw.png";
import han_dus_sup from "../img/sswpIcons/HandTools/han_dus_sup.png";
import han_gua from "../img/sswpIcons/HandTools/han_gar.png";
import han_gen_out from "../img/sswpIcons/HandTools/han_gen_out.png";
import han_jac_ham_vib from "../img/sswpIcons/HandTools/han_jac_ham_vib.png";
import han_per_work from "../img/sswpIcons/HandTools/han_per_work.png";
import han_sel_sui from "../img/sswpIcons/HandTools/han_sel_sui.png";
import han_vol from "../img/sswpIcons/HandTools/han_vol.png";
import han_mai from "../img/sswpIcons/HandTools/han_mai.png";
import han_rep_dam_par from "../img/sswpIcons/HandTools/han_rep_dam_par.png";
import han_wel_fla_cut from "../img/sswpIcons/HandTools/han_fla_cut.png";
import han_pow_flo from "../img/sswpIcons/HandTools/han_pow_flo.png";
import han_car from "../img/sswpIcons/HandTools/han_car_too.png";
import han_pai_spr from "../img/sswpIcons/HandTools/han_pai_spr.png";
import han_san from "../img/sswpIcons/HandTools/han_san.png";
import han_gas_fla_arr from "../img/sswpIcons/HandTools/han_gas_fla_arr.png";
import han_sit_spe_met_sta from "../img/sswpIcons/HandTools/han_sit_spe_met.png";

const json = {
    icon: han_haz_lev,
    name: "Hand Tools",
    text: "",
    icons: {
        han_sel_sui: {
            name: "Selection/ Suitability",
            icon: han_sel_sui,
            text: (
                <ul>
                    <ListItem text="Before carrying out an activity the plant/equipment must be checked for it’s suitability for the task (e.g. Safe Working Load, capacity, voltage rating, reach capability, available accessories etc)" />
                </ul>
            )
        },
        han_vol: {
            name: "Voltage",
            icon: han_vol,
            text: (
                <ul>
                    <ListItem text="All portable electric tools must be rated at 110 V or less, unless it’s rating exceeds 2 kVA." />
                    <ListItem text="You should use cordless tools or those that operate from a 110V centre tapped to earth supply system so that the maximum voltage to earth does not exceed 55V." />
                    <ListItem text="Tools should only be serviced by qualified electricians. DO not makeshift repairs " />
                    <ListItem text="Do NOT use tools/cords that have been repaired with insulating tape." />
                    <ListItem text="Make sure the tool/ cord is completely plugged in at the plug. Do not force plugs into sockets." />
                    <Li>
                        <Typography variant="title">Extension Cords</Typography>
                        <ol>
                            <ListItem text="Check for damage before each use" />
                            <ListItem text="They must be CE Marked" />
                            <ListItem text="They must be marked for indoor/outdoor. Never use a cord outdoors that is marked for indoor use." />
                            <ListItem text="Make sure extension cord is unplugged when not actively being used." />
                            <ListItem text="Store cords indoors. Keep cords away from water." />
                            <ListItem text="Do not plug one extension cord into another. This will exceed the cord rating and could cause a fire." />
                            <ListItem text="Don’t run cord across doorways, or through walls or holes in ceilings, or the middle of floors. Cords must NOT be affixed to walls/ceilings using nails or staples." />
                            <ListItem text="You cannot traffic extension cords. Any trafficked extension cord must be covered by a protector. Floor cable protectors should be highly visible. " />
                            <ListItem text="If using a cable drum, it should be completely unwound to avoid overheating." />
                        </ol>
                    </Li>
                    <ListItem text="The supply must have an RCD, which must be tested regularly. In the event of an emergency, a surge protector will cut off the site’s power supply. A voltage regulator protects equipment from spikes in voltage. " />
                    <ListItem text="Do not use cords to carry, lower or raise tools. " />
                    <ListItem text="Do not have tools plugged in when not working, making adjustments or replacing/changing parts." />
                </ul>
            )
        },
        han_gar: {
            name: "Guards",
            icon: han_gua,
            text: (
                <ul>
                    <ListItem text="All tools, plant and equipment must be operated in accordance with the manufacturer’s instructions. This includes the requirement for guards. Any powered moving or rotating part should be protected by a guard." />
                    <ListItem text="The tool, plant or equipment cannot be operated where guards are missing." />
                    <ListItem text="The guard should be checked for condition and security of fit." />
                    <ListItem text="Movable guards must be positioned in accordance with the task and the manufacturer’s instruction." />
                </ul>
            )
        },
        han_cab_che: {
            name: "Cable Check",
            icon: han_cab_che,
            text: (
                <ul>
                    <ListItem text="Check the condition of all cables (tools, extension leads) prior to each use. Check for cracking, fraying or any other signs of wear. " />
                    <ListItem text="If a fault is found, immediately remove it from service and tag it clearly with “Out of Service for Repair”" />
                    <ListItem text="Never carry tools by their cords. Do not tie cords in knots" />
                    <ListItem text="Cables must have a three-prong plug, and be double insulated/ or be low voltage. Ensure there is always a connection to a functioning ground" />
                    <ListItem text="Extension leads should be fully unwound if used. Do not splice extension cords together to make a longer connection." />
                </ul>
            )
        },
        han_cab_pro: {
            name: "Cable Protection",
            icon: han_cab_pro,
            text: (
                <ul>
                    <ListItem text="Any trailing cables should be protected from damage" />
                </ul>
            )
        },
        han_mai: {
            name: "Maintenance",
            icon: han_mai,
            text: (
                <ol>
                    <ListItem text="All equipment and tools must be regularly checked and maintained in accordance with the manufacturer’s instructions." />
                    <ListItem text="This must be done by a competent person, and should be recorded for reference. It is good practice to use a tagging system that includes the date completed and any next scheduled date." />
                </ol>
            )
        },
        han_rep_dam_par: {
            name: "Replace Damaged Parts",
            icon: han_rep_dam_par,
            text: (
                <ul>
                    <ListItem text="All equipment should be checked before use, including leads, plugs and attachments." />
                    <ListItem text="Any damaged parts must be replaced before use." />
                    <ListItem text="If this is not possible, then the equipment should be tagged “Do Not Use” and sent for repair." />
                </ul>
            )
        },
        han_gen_out: {
            name: "Generators Outside",
            icon: han_gen_out,
            text: (
                <ul>
                    <ListItem text="All diesel or petrol generators must be placed outdoors in a well-ventilated area to prevent carbon monoxide poisoning." />
                </ul>
            )
        },
        han_dus_sup: {
            name: "Dust Suppression",
            icon: han_dus_sup,
            text: (
                <ul>
                    <ListItem text="Should be fitted to tools that generate dust" />
                    <ListItem text="May be in the form of extraction of wetting aids" />
                </ul>
            )
        },
        han_con_saw: {
            name: "Con Saw/ Angle Grinder/ Abrasive Wheels",
            icon: han_con_saw_abr_whe,
            text: (
                <ul>
                    <ListItem text="Only trained operatives can use this equipment." />
                    <ListItem text="The tool must be properly and regularly maintained" />
                    <ListItem text="The tool needs to be visually checked for good condition prior to use. Damaged or improperly functioning tools must be put out of service and marked “Out of Service”, including any tool where the wheel turns while idling. The tool must be kept clean." />
                    <ListItem text="Tools must have guards fitted and these must be properly adjusted prior to use." />
                    <ListItem text="The correct wheel must be chosen for the material being worked on and the maximum operating speed must not be exceeded. The wheel must be in good condition." />
                    <ListItem text="You can only use the tool on level stable ground/platform on material that is properly secured/stable." />
                    <ListItem text="Check the material you are going to cut for other foreign material that is not compatible with the wheel." />
                    <ListItem text="The tool must be switched off (and unplugged) prior to changing the wheel or carrying out any maintenance activity." />
                    <ListItem text="Any cords must be kept away from the cutting area." />
                    <ListItem text="Ensure the wheel has stopped rotating before putting tool down after the cut." />
                    <ListItem text="You must wear eye protection to minimum IS EN 166 Class B and Ear Protection to IS EN 352. You should wear gloves, close fitting overalls, and safety boots. You should wear a dust mask." />
                    <ListItem text="You must have a first aid kit (that includes a large wound dressing)" />
                </ul>
            )
        },
        han_cha_saw_ppe: {
            name: "Chainsaw/ Training/ PPE",
            icon: han_cha_saw_ppe,
            text: (
                <ul>
                    <ListItem text="The operative must be properly trained for the scale of the task they are to undertake while using the chainsaw. They must plan their task, including cut locations and methodologies, before beginning. Ensure the area is as clear as possible before beginning." />
                    <ListItem text="The chainsaw must be well maintained, and clean. The chain must not be turning while the machine idles. The air filter must be clean, engine tuned and chain correctly sharpened and tightened." />
                    <ListItem text="You must wear Safety Helmet, Eye Protection (safety visor or safety glasses) and ear defenders." />
                    <ListItem text="You should wear chainsaw gloves; leg protection incorporating clogging material (IS EN 381-7)/Chainsaw trousers (IS EN 381-5); Safety boots; Non-snag close fitting outer clothing." />
                    <ListItem text=" You must have a first aid kit (that includes a large wound dressing)" />
                    <ListItem text="The engine must be shut off when moving from one area to another. An idling saw must never be left unattended." />
                    <ListItem text="Chainsaws must be used in a right handed manner, with right hand on throttle and left hand holding handle, and left thumb under this handle at all times." />
                    <ListItem text="The operator must know where all the controls are located and know how to stop the saw in an emergency." />
                    <ListItem text="When starting the saw must be held firmly in position at ground level by placing the right foot on the handle, making sure the chain is clear. The front handle is held with the left hand and the cord is pulled by the right hand." />
                    <ListItem text="The chain brake must be used while not cutting" />
                    <ListItem text="The chainsaw must NEVER by used above shoulder height, when off-balance, or on a ladder. It must not be used if the operative is tired or fatigued" />
                    <ListItem text="The chainsaw is a one-person operation, a safe distance must be maintained from other persons." />
                    <ListItem text="Avoid working alone when using a chainsaw" />
                </ul>
            )
        },
        han_fla_cut: {
            name: "Welder/ Flame Cutter",
            icon: han_wel_fla_cut,
            text: (
                <ul>
                    <ListItem text="This is only permitted where there is no risk of fire or explosion." />
                    <ListItem text="Generally, only oxy-fuel gases and disc grinders should be used." />
                    <ListItem text="Operators need to be trained in the operation" />
                    <ListItem text="The area must be cleared of other workers, and well ventilated and proper fume handling controls are required" />
                    <ListItem text=" A permit to work system should be used" />
                    <ListItem text="The equipment needs to be well maintained, properly serviced." />
                    <ListItem text="You need proper storage and handling facilities for the gas cylinders" />
                    <ListItem text=" You must wear appropriate PPE" />
                </ul>
            )
        },
        han_pow_flo: {
            name: "Power Floating",
            icon: han_pow_flo,
            text: (
                <ul>
                    <ListItem text="Make sure you are familiar with the manufacturer’s instruction manual" />
                    <ListItem text="Inspect for damage or wear before each use" />
                    <ListItem text="Do not use if the hand grips are damaged. All guards must be place and in good condition." />
                    <ListItem text="Any opening or edges must have edge protection" />
                    <ListItem text="Wear steel toe-cap wellies, gloves, hard hat, eye and ear protection. Wear snug fitting clothes/ overalls" />
                </ul>
            )
        },
        han_jac_ham_vib: {
            name: "Jack Hammer Vibration Controls",
            icon: han_jac_ham_vib,
            text: (
                <ul>
                    <ListItem text="These controls are applicable when operatives are using any vibrating tools, equipment or plant. The main risk is to health from long term exposure." />
                    <ListItem text="Any handles, or vibration damping attachments provided must be used by operatives" />
                    <Li>
                        <Typography variant="title">
                            For guidance only, maximum operation times/ day
                            should be limited to
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Tool</th>
                                    <th>Typical Tool</th>
                                    <th>Modern Tool</th>
                                </tr>
                                <tr>
                                    <td>Road Breaker</td>
                                    <td>1 hour 23 min (12 m/s2)</td>
                                    <td>8 hours (5 m/s2)</td>
                                </tr>
                                <tr>
                                    <td>Demolition Hammer</td>
                                    <td>0 hour 53 min (15 m/s2) </td>
                                    <td>3 hour 8 min (8 m/s2)</td>
                                </tr>
                                <tr>
                                    <td>Hammer Drill</td>
                                    <td>2 hour 28 min (9 m/s2)</td>
                                    <td>5 hour 33 min (6 m/s2)</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                </ul>
            )
        },
        han_car_too: {
            name: "Cartridge Tools",
            icon: han_car,
            text: (
                <ul>
                    <ListItem text="Cartridge tools must be well maintained and kept clean" />
                    <ListItem text="The tool operator must be trained in it’s use. The tool operator must have read and follow the manufacturer’s instructions for use. Operator must follow mis-fire procedure if it occurs (waiting at least 30 seconds after mis-fire)" />
                    <ListItem text="Follow the selection process for fastner, tool cartridge and accessory." />
                    <ListItem text="Carry out test fixing to confirm suitablility" />
                    <ListItem text="Keep arms relaxed while operating" />
                    <ListItem text="The operator must wear eye protection to IS EN 166 Class B and Ear Protection to IS EN 352." />
                    <ListItem text="Always remove cartridges prior to any maintenance of the tool (caution – tool may be hot)." />
                    <ListItem text="Remove cartridges after use and store in accordance with their safety data sheets. Put tool back in case and store securely." />
                </ul>
            )
        },
        han_pai_spr: {
            name: "Paint Sprayer",
            icon: han_pai_spr,
            text: (
                <ul>
                    <ListItem text="Choose the correct equipment for the task. Conventional sprayers use compressed air to atomise the paint, leading to a lot of overspray/ mist in the air that can travel significant distances. High-volume low-pressure guns limit this risk. There are also airless options (that just forces through paint through nozel) limiting overspray/ mist, but the tip of these devices need adequate protection to prevent paint injection into skin." />
                    <ListItem text="You must follow the sprayer manufacturer’s instruction’s and the requirements on the paint’s Safety Data Sheets." />
                    <ListItem text="Ensure good ventilation. You should consider use of mechanical ventilation in area. In enclosed areas you need to assess if confined space controls should be selected. Such areas will also require you to assess if fire/ explosion controls will be required." />
                    <ListItem text="Keep all non-essential operatives away from work area. You may need to use barriers to achieve this. Take account of wind direction, if working outside. (Wind direction may change during the day)." />
                    <ListItem text="Keep the spray-gun clean. Ensure proper controls are in place if using thinner to clean gun, as risks are still present." />
                    <ListItem text="Masks with tear-off visors will improve visibility and reduce risk of overspray and bounce back." />
                    <Li>
                        <Typography variant="title">
                            General advice when selecting appropriate masks
                        </Typography>
                        <ol>
                            <ListItem text="Half face mask with A1p3 filter(s) for intermittently spraying lower solvent volumes over a shift with little general ventilation" />
                            <ListItem text="Powered (fan-assissted) respirator with a visor and A2P3 filter(s) for longer tasks like spraying lower solvent products consistently during shift" />
                            <ListItem text="Constant flow air-fed breathing apparatus with a low flow indicator for spraying high solvent products, particularly in an enclosed space. The fed-in air must be uncontaminated." />
                        </ol>
                    </Li>
                </ul>
            )
        },
        han_san: {
            name: "Sander",
            icon: han_san,
            text: (
                <ul>
                    <ListItem text=" The sander should have a dust catching system or vacuum system" />
                    <ListItem text=" Never change the sandpaper while the sander is plugged in. Make sure there is no electric current before making any changes to the tool" />
                    <ListItem text="Place the tool onto the wood surface before turning on the tool." />
                    <ListItem text="Do not remove the tool from the surface until you have turned the tool off, and it has stopped rotating" />
                    <ListItem text=" Wear eye protection and dust mask/ respirator." />
                </ul>
            )
        },
        han_com_whi_che: {
            name: "Compressor & Whip Check",
            icon: han_com_whi_che,
            text: (
                <ul>
                    <ListItem text="Compressors and connection must be properly and regularly maintained." />
                    <ListItem text="All connections and hosing must be visually inspected before each use for good condition. Damaged or worn items must be put out of use and marked “Out of Service”." />
                    <ListItem text="The compressor can only run when all guards are in place." />
                    <ListItem text="Safety clips must also be checked before operation." />
                    <ListItem text="The system must have an automatic cut-off valve or hose safety whip checks" />
                    <ListItem text="When used, Hose safety whip checks should be in-place on all pressurised hose applications. They should be installed in the fully extended position (no slack). Spring-loaded loops easily adjust to slip over couplings for a firm grip on the hose. They must be properly rated to match the compressor pressure." />
                </ul>
            )
        },
        han_gas_fla_arr: {
            name: "Gas/ Flame Arrester",
            icon: han_gas_fla_arr,
            text: (
                <ul>
                    <ListItem text="Flashback arrestors incorporate a cut off valve to shut off the gas and are fitted to the gas supply/ or oxygen supply line." />
                    <ListItem text=" They must be fitted when using cutting or welding tools." />
                </ul>
            )
        },
        han_per_work: {
            name: "Permit to Work",
            icon: han_per_work,
            text: (
                <ul>
                    <ListItem text="This formal system ensures the required controls are in place before beginning a task with a high risk hazard." />
                    <ListItem text="The permit system identifies the controls that must be in place to allow the task to begin. The implementation of these controls must be signed off by an appointed seperate individual, before an operative is permitted to begin the task." />
                    <ListItem text="The permit system should also state the conditions to be met after work is completed and be signed off by the operative (and verified by the appointed individual)." />
                </ul>
            )
        },
        han_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: han_sit_spe_met_sta,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};

export default json;
